import { render } from "./UserBar.vue?vue&type=template&id=abbf79d8"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import "./UserBar.vue?vue&type=style&index=0&id=abbf79d8&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__